import React, { useEffect, useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import API_BASE_URL from '../config';
import './Login.css';

function Login() {
  const { loginWithGoogle, error, setError, loading } = useAuth();
  const [googleClientId, setGoogleClientId] = useState(null);
  const [allowedDomains, setAllowedDomains] = useState([]);
  const [configLoading, setConfigLoading] = useState(true);

  // Fetch auth config on mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/auth/config`);
        if (response.data.success) {
          setGoogleClientId(response.data.googleClientId);
          setAllowedDomains(response.data.allowedDomains || []);
        }
      } catch (err) {
        console.error('Failed to fetch auth config:', err);
        setError('Failed to load authentication configuration');
      } finally {
        setConfigLoading(false);
      }
    };

    fetchConfig();
  }, [setError]);

  const handleSuccess = async (credentialResponse) => {
    const result = await loginWithGoogle(credentialResponse.credential);
    if (!result.success) {
      console.error('Login failed:', result.error);
    }
  };

  const handleError = () => {
    setError('Google Sign-In failed. Please try again.');
  };

  if (configLoading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-loading">Loading...</div>
        </div>
      </div>
    );
  }

  if (!googleClientId) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>AME API Platform</h1>
            <p>Configuration Error</p>
          </div>
          <div className="login-error">
            Google OAuth is not configured. Please contact administrator.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <svg viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
          </div>
          <h1>AME API Platform</h1>
          <p>Insurance Integration System</p>
        </div>

        <div className="login-body">
          <h2>Sign In</h2>
          <p className="login-subtitle">
            Use your company Google account to continue
          </p>

          {allowedDomains.length > 0 && (
            <p className="login-domain-info">
              Allowed domains: {allowedDomains.join(', ')}
            </p>
          )}

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <div className="google-login-wrapper">
            <GoogleOAuthProvider clientId={googleClientId}>
              <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
                useOneTap
                theme="outline"
                size="large"
                width="300"
                text="signin_with"
                shape="rectangular"
                logo_alignment="left"
              />
            </GoogleOAuthProvider>
          </div>

          {loading && (
            <div className="login-loading">
              Signing in...
            </div>
          )}
        </div>

        <div className="login-footer">
          <p>Powered by Click Insurance Broker Co.,Ltd.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
